import React, { useState } from 'react';
import { useTheme } from '@root/context/ThemeContext';
import Loader from '@root/components/common/Loader';
const simpleBitbucketYaml = `# Simple bitbucket-pipelines.yml for Node.js

image: node:16-alpine

pipelines:
  default:
    - step:
        name: Build and Test
        caches:
          - node
        script:
          # Install dependencies
          - npm ci
          
          # Run linting
          - npm run lint
          
          # Run tests
          - npm test
          
          # Build the application
          - npm run build
        
        # Save build artifacts
        artifacts:
          - dist/**
          - build/**

  branches:
    main:
      - step:
          name: Build, Test and Deploy
          deployment: production
          caches:
            - node
          script:
            # Install dependencies
            - npm ci
            
            # Run tests with coverage
            - npm run test:coverage
            
            # Build for production
            - npm run build:prod
            
            # Deploy (example using SSH)
            - pipe: atlassian/ssh-run:0.4.1
              variables:
                SSH_USER: $DEPLOY_USER
                SERVER: $PROD_SERVER
                COMMAND: 'cd /var/www/app && ./deploy.sh'

# Define node cache
definitions:
  caches:
    node: node_modules`;
const SimpleYamlViewer = ({
  yamlContent = simpleBitbucketYaml,
  title = 'YAML Script',
  height = '400px',
  isLoading,
}) => {
  const { isDarkMode } = useTheme();
  const [copyButtonText, setCopyButtonText] = useState('Copy');

  const lines = yamlContent ? yamlContent.split('\n') : [];

  const handleCopy = () => {
    navigator.clipboard.writeText(yamlContent).then(() => {
      setCopyButtonText('Copied!');
      setTimeout(() => setCopyButtonText('Copy'), 2000);
    });
  };

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      fontFamily: 'Manrope',
      fontSize: '13px',
      border: `1px solid ${isDarkMode ? '#4a5568' : '#e0e0e0'}`,
      overflow: 'hidden',
      borderRadius: '4px',
      backgroundColor: isDarkMode ? '#1a202c' : '#ffffff',
      height: height,
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 16px',
      backgroundColor: isDarkMode ? '#2d3748' : '#f5f5f5',
      borderBottom: `1px solid ${isDarkMode ? '#4a5568' : '#e0e0e0'}`,
    },
    headerTitle: {
      fontWeight: 'bold',
      color: isDarkMode ? '#f7fafc' : '#1a202c',
    },
    copyButtonYaml: {
      padding: '4px 12px',
      backgroundColor: 'transparent',
      border: `1px solid ${isDarkMode ? '#4a5568' : '#e0e0e0'}`,
      borderRadius: '4px',
      color: isDarkMode ? '#f7fafc' : '#1a202c',
      cursor: 'pointer',
      fontSize: '12px',
      fontWeight: '500',
    },
    contentContainer: {
      flex: 1,
      overflowY: 'auto',
      overflowX: 'auto',
      backgroundColor: isDarkMode ? '#1e2329' : '#ffffff',
    },
    lineRow: {
      display: 'flex',
      minHeight: '22px',
      lineHeight: '22px',
      // borderBottom: `1px solid ${isDarkMode ? '#2d3748' : '#f0f0f0'}`,
    },
    lineNumber: {
      width: '50px',
      flexShrink: 0,
      textAlign: 'right',
      padding: '0 16px 0 8px',
      backgroundColor: isDarkMode ? '#2d3748' : '#f8f8f8',
      color: isDarkMode ? '#718096' : '#999',
      borderRight: `1px solid ${isDarkMode ? '#4a5568' : '#e0e0e0'}`,
      userSelect: 'none',
    },
    lineContent: {
      fontFamily: 'SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace',
      padding: '0 16px',
      whiteSpace: 'pre',
      flex: '1 1 auto',
      color: isDarkMode ? '#f7fafc' : '#1a202c',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.headerTitle}>{title}</span>
        <button style={styles.copyButtonYaml} onClick={handleCopy}>
          {copyButtonText}
        </button>
      </div>
      <div style={styles.contentContainer}>
        {isLoading ? (
          <Loader />
        ) : (
          lines.map((line, idx) => (
            <div key={`line-${idx}`} style={styles.lineRow}>
              <div style={styles.lineNumber}>{idx + 1}</div>
              <div style={styles.lineContent}>{line}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SimpleYamlViewer;
